import {RepositoryLabelToken} from '@github-ui/label-token/RepositoryLabelToken'
import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {Link, Tooltip} from '@primer/react'
import {clsx} from 'clsx'
import {useMemo} from 'react'

import {VALUES} from '../constants/values'
import type {LabelNode} from './issue-viewer-view-query-types'
import labelStyles from './Label.module.css'
import styles from './labels.module.css'

// RELAY-CLEANUP(LabeledEvent): widens nullable fields so the still-Relay parent data is assignable.
// Remove when LabeledEvent and UnlabeledEvent leave Relay.
export type LabelFragment = RelayCompat<Pick<LabelNode, 'color' | 'description' | 'id' | 'name' | 'nameHTML'>>

type LabelProps = {
  label: LabelFragment
  timelineEventBaseUrl: string
}

export function Label({label, timelineEventBaseUrl}: LabelProps): React.ReactElement {
  const {name, id, description} = label
  const url = useMemo(() => {
    return `${timelineEventBaseUrl}?q=${encodeURIComponent(VALUES.labelQuery(name))}`
  }, [timelineEventBaseUrl, name])

  return (
    <Tooltip
      text={description ?? ''}
      className={clsx(labelStyles.labelDescriptionTooltip, !description && labelStyles.hiddenTooltip)}
    >
      <Link href={url} className={styles.labelLink} aria-describedby={`${id}-tooltip`} muted>
        <RepositoryLabelToken
          label={label}
          key={id}
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '20ch',
            cursor: 'pointer',
          }}
        />
        <span className="sr-only" id={`${id}-tooltip`}>
          {description ?? ''}
        </span>
      </Link>
    </Tooltip>
  )
}
